import { withProps, compose } from 'recompose';
import queryString from 'query-string';
import { connect } from 'react-redux';

const mapStateToProps = store => ({
  queryParams: store.routing.location
    ? queryString.parse(store.routing.location.search) || {}
    : {}
});

export default compose(
  connect(mapStateToProps),
  withProps(({ queryParams, staticContext }) => {
    if (staticContext && Object.keys(staticContext).length > 0) {
      return { queryParams: staticContext.queryParams || {} };
    }
    if (queryParams && Object.keys(queryParams).length > 0) {
      return { queryParams };
    }
    if (__CLIENT__ && typeof window.location !== 'undefined') {
      return { queryParams: queryString.parse(window.location.search) || {} };
    }
    return {};
  })
);
